import { Button, DatePicker, Input, Table } from "antd";
import dayjs, { Dayjs } from "dayjs";
import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import dateIcon from "../../images/from-to-icon.svg";
import searchIcon from "../../images/search_icon.png";
import { api } from "../../utils/api";
import { PAGE, PAGE_SIZE } from "../../utils/constants/common";
import { ColumnsRecorb } from "./LisenceMangement/Column";
import PaginationComponent from "./LisenceMangement/Pagination";

const dateFormat = "YYYY-MM-DD";

function AdminRecorbManagement() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [list, setList] = React.useState<[]>([]);

  const [total, setTotal] = React.useState(0);
  const page = Number(searchParams.get("page") || PAGE);
  const pageSize = Number(searchParams.get("pageSize") || PAGE_SIZE);
  const searchTerm = searchParams.get("search") || "";
  const startDate = searchParams.get("startDate") || "";
  const endDate = searchParams.get("endDate") || "";

  const [searchInput, setSearchInput] = React.useState(searchTerm);
  const [startDateInput, setStartDateInput] = useState<Dayjs | null>(
    startDate ? dayjs(startDate) : null,
  );

  const [endDateInput, setEndDateInput] = useState<Dayjs | null>(
    endDate ? dayjs(endDate) : null,
  );

  const getData = useCallback(async () => {
    const res = await api.get(`api/admin/app-download-jobs`, {
      params: {
        page: page,
        pageSize: pageSize,
        search: searchTerm,
        startDate: startDate,
        endDate: endDate,
      },
    });
    setList(res.data.items);
    setTotal(res.data.total);
  }, [page, pageSize, searchTerm, startDate, endDate]);

  useEffect(() => {
    getData();
  }, [getData]);


  const onSearch = () => {
    const trimmedSearchInput = searchInput.trim();
    setSearchInput(trimmedSearchInput);

    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (trimmedSearchInput) {
        params.set("search", trimmedSearchInput);
      } else {
        params.delete("search");
      }
      if (startDateInput) {
        params.set("startDate", startDateInput.startOf("day").toISOString());
      } else {
        params.delete("startDate");
      }
      if (endDateInput) {
        params.set("endDate", endDateInput.endOf("day").toISOString());
      } else {
        params.delete("endDate");
      }
      params.set("page", "1");
      return params;
    });
  };

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value.trimStart());
  };

  const handleSearchInputBlur = () => {
    setSearchInput((value) => value.trim());
  };

  return (
    <>
      <div className="flex justify-between items-center h-[46px] mb-4">
        <div className="flex gap-3 h-full">
          <Input
            maxLength={255}
            placeholder="SN・代理店名で検索"
            className="base-input h-11 w-[424px]"
            suffix={<img src={searchIcon} className="h-6" alt="search icon" />}
            onChange={handleSearchInputChange}
            onBlur={handleSearchInputBlur}
            value={searchInput}
          />
          <div className="h-full flex items-center gap-2">
            <DatePicker
              value={startDateInput}
              onChange={(date) => setStartDateInput(date)}
              maxDate={dayjs(endDateInput, dateFormat)}
              className="h-full"
            />
            <img src={dateIcon} alt="" />
            <DatePicker
              value={endDateInput}
              onChange={(date) => setEndDateInput(date)}
              minDate={dayjs(startDateInput, dateFormat)}
              className="h-full"
            />
          </div>
          <div className="flex items-center gap-2 justify-end flex-1">
            <Button
              onClick={() => onSearch()}
              className="h-[46px] w-[52px] base-button"
            >
              検索
            </Button>
          </div>
        </div>
      </div>
      <Table
        columns={ColumnsRecorb(page, pageSize)}
        dataSource={list}
        pagination={false}
        scroll={{ x: 1074 }}
        tableLayout="fixed"
        className="custom-table"
        rowKey={(list) => list.id?.toString() ?? ""}
      />
      <PaginationComponent total={total} />
    </>
  );
}

export default AdminRecorbManagement;
